import ReactDraggable from 'react-draggable';

import { Content } from './draggable.styled';

export const Draggable = (props) => {
  const { children, width, height, bounds = '.app-content', ...rest } = props;
  return (
    <ReactDraggable bounds={bounds} {...rest}>
      <Content width={width} height={height}>
        {children}
      </Content>
    </ReactDraggable>
  );
};
